import {Injectable} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {LayoutService} from 'app/core/services/layout.service';
import {AppUrls} from 'app/core/url/app-urls.service';
import {PosthogService} from 'app/core/services/analytics/posthog.service';

@Injectable()
export class AbTestService {
    appUrls = AppUrls;

    constructor(
        public router: Router,
        public activatedRoute: ActivatedRoute,
        public layout: LayoutService,
        private posthog: PosthogService
    ) {}

    setAbTestSrc(src: string, queryParams: Params) {
        if (!src || ('src' in queryParams && String(queryParams.src) === String(src))) {
            return;
        }

        return this.router.navigate([this.appUrls.SIGN_UP], {
            replaceUrl: true,
            queryParamsHandling: 'merge',
            queryParams: {
                ...queryParams,
                src,
            },
        });
    }

    getVariant(queryParams: Params): string {
        if (queryParams.src && queryParams.src === 'extra-fields') {
            return 'extra-fields';
        }
        if (this.posthog.getFeatureFlag('sign-up-extra-field-hear-about-us') === 'extra-fields') {
            // Do something differently for this user
            return 'extra-fields';
        } else {
            // It's a good idea to let control variant always be the default behaviour,
            // so if something goes wrong with flag evaluation, you don't break your app.
            return '';
        }
    }
}
